import * as THREE from 'three';
import { Base3DPart } from "./base-part";
import { TramoggiaState } from './tramoggia-part';

export class Slide3DPart extends Base3DPart {
    private position: number;
    private offset: THREE.Vector3;
    private isHalfSlide: boolean;
    private curve!: THREE.CatmullRomCurve3;
    private filteredCurve!: THREE.CatmullRomCurve3;
    private arrows: THREE.Group[] = [];
    private filteredArrows: THREE.Group[] = [];
    private animationIsRunning: boolean = false;
    private _state: TramoggiaState = TramoggiaState.RUNNING;
    private _type: string = 'Fenix';

    constructor(position: number, isHalfSlide: boolean, type: string) {
        let offset = new THREE.Vector3(0, position * 5, 0);
        if (type === 'Hyperion') {
            offset = new THREE.Vector3(0, position * 4.8, 0);
        } else if (type === 'Optica') {
            offset = new THREE.Vector3(0, position * 3.9, 0);
        }
        super(type, true);
        this.offset = offset;
        this.position = position;
        this.isHalfSlide = isHalfSlide;
        this._type = type;
    }

    override load(scene: THREE.Scene): void {
        let paths = [
            `${this.basePath}/scivolo/scivolo.gltf`,
            `${this.basePath}/scivolo/vibratore-engine.gltf`,
            `${this.basePath}/scivolo/soffio.gltf`,
            `${this.basePath}/scivolo/soffio-diod.gltf`,
            // `${this.basePath}/scivolo/soffio-numbers.gltf`
        ];

        if (this._type === 'Hyperion') {
            paths[1] = `${this.basePath}/scivolo/vibratore-engine-front.gltf`;
            paths.push(`${this.basePath}/scivolo/vibratore-engine-back.gltf`);
        }

        paths.forEach((path, index) => {
            this.gltfLoader.load(path, (gltf) => {
                if (this.isHalfSlide) {
                    gltf.scene.scale.set(1, 0.5, 1);
                    gltf.scene.position.add(new THREE.Vector3(0, -5, 0));
                }
                gltf.scene.position.add(this.offset);
                scene.add(gltf.scene);
            });
        });
    }

    public setState(state: TramoggiaState, scene: THREE.Scene) {
        this._state = state;
        if (state === TramoggiaState.RUNNING || state === TramoggiaState.PAUSED) {
            if (!this.animationIsRunning) {
                this.playArrowAnimation(scene);
            }
        } else {
            this.stopArrowAnimation(scene);
        }
    }

    public createPath(): void {
        // Define a path using CatmullRomCurve3
        if (this._type === 'Optica') {
            if (this.isHalfSlide) {
                this.curve = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(0, (this.position * 3.9) - 8.7, 35),
                    new THREE.Vector3(0, (this.position * 3.9) - 8.7, 11),
                    new THREE.Vector3(-4.5, (this.position * 3.9) - 8.7, 9),
                    new THREE.Vector3(3, (this.position * 3.9) - 8.7, -6),
                    new THREE.Vector3(3.8, (this.position * 3.9) - 8.7, -25)
                ]);
    
                this.filteredCurve = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(3, (this.position * 3.9) - 8.7, -5),
                    new THREE.Vector3(6, (this.position * 3.9) - 8.7, -8),
                    new THREE.Vector3(10, (this.position * 3.9) - 8.7, -25)
                ]);
            } else {
                this.curve = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(0, (this.position * 3.9) - 7.5, 35),
                    new THREE.Vector3(0, (this.position * 3.9) - 7.5, 13),
                    new THREE.Vector3(-4, (this.position * 3.9) - 7.5, 10),
                    new THREE.Vector3(3, (this.position * 3.9) - 7.5, -6),
                    new THREE.Vector3(6, (this.position * 3.9) - 7.5, -25)
                ], false, 'catmullrom', 0.3);
    
                this.filteredCurve = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(3, (this.position * 3.9) - 7.5, -5),
                    new THREE.Vector3(6, (this.position * 3.9) - 7.5, -8),
                    new THREE.Vector3(11, (this.position * 3.9) - 7.5, -25)
                ]);
            }
        } else if (this._type === 'Hyperion') {
            if (this.isHalfSlide) {
                this.curve = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(-13.8, (this.position * 4.8) - 8.7, 30),
                    new THREE.Vector3(-13.8, (this.position * 4.8) - 8.7, 12.25),
                    new THREE.Vector3(-3.5, (this.position * 4.8) - 8.7, 9.3),
                    new THREE.Vector3(1.6, (this.position * 4.8) - 8.7, 1),
                    new THREE.Vector3(2.5, (this.position * 4.8) - 8.7, -3.5),
                    new THREE.Vector3(8, (this.position * 4.8) - 8.7, -20)
                ], false, 'catmullrom', 0.25);
    
                this.filteredCurve = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(1.6, (this.position * 4.8) - 8.7, 1),
                    new THREE.Vector3(2.8, (this.position * 4.8) - 8.7, 0),
                    new THREE.Vector3(14, (this.position * 4.8) - 8.7, -20)
                ]);
            } else {
                this.curve = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(-13.8, (this.position * 4.8) - 7.5, 30),
                    new THREE.Vector3(-13.8, (this.position * 4.8) - 7.5, 12.25),
                    new THREE.Vector3(-3.5, (this.position * 4.8) - 7.5, 9.3),
                    new THREE.Vector3(1.6, (this.position * 4.8) - 7.5, 1),
                    new THREE.Vector3(2.5, (this.position * 4.8) - 7.5, -3.5),
                    new THREE.Vector3(8, (this.position * 4.8) - 7.5, -20)
                ], false, 'catmullrom', 0.25);
    
                this.filteredCurve = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(1.6, (this.position * 4.8) - 7.5, 1),
                    new THREE.Vector3(2.8, (this.position * 4.8) - 7.5, 0),
                    new THREE.Vector3(14, (this.position * 4.8) - 7.5, -20)
                ]);
            }
        } else {
            if (this.isHalfSlide) {
                this.curve = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(-8, (this.position * 5) - 8.7, 35),
                    new THREE.Vector3(-8, (this.position * 5) - 8.7, 11),
                    new THREE.Vector3(-4.5, (this.position * 5) - 8.7, 9),
                    new THREE.Vector3(3, (this.position * 5) - 8.7, -6),
                    new THREE.Vector3(3.8, (this.position * 5) - 8.7, -25)
                ]);
    
                this.filteredCurve = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(3, (this.position * 5) - 8.7, -5),
                    new THREE.Vector3(6, (this.position * 5) - 8.7, -8),
                    new THREE.Vector3(10, (this.position * 5) - 8.7, -25)
                ]);
            } else {
                this.curve = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(-8, (this.position * 5) - 7.5, 35),
                    new THREE.Vector3(-8, (this.position * 5) - 7.5, 11),
                    new THREE.Vector3(-4.5, (this.position * 5) - 7.5, 9),
                    new THREE.Vector3(3, (this.position * 5) - 7.5, -6),
                    new THREE.Vector3(3.8, (this.position * 5) - 7.5, -25)
                ]);
    
                this.filteredCurve = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(3, (this.position * 5) - 7.5, -5),
                    new THREE.Vector3(6, (this.position * 5) - 7.5, -8),
                    new THREE.Vector3(10, (this.position * 5) - 7.5, -25)
                ]);
            }
        }        
    }

    private createArrows(scene: THREE.Scene) {
        let baseArrowColor = 0x00ff00;
        let filteredArrowColor = 0xff0000;

        if (this._state === TramoggiaState.PAUSED) {
            baseArrowColor = 0x999999;
            filteredArrowColor = 0x999999;
        }

        /// Create 20 arrows green and add them to the scene
        this.arrows = [];
        for (let i = 0; i < 13; i++) {
            const arrow = this.createArrow(baseArrowColor);
            this.arrows.push(arrow);
            scene.add(arrow);
        }

        /// Create 5 arrows red and add them to the scene
        this.filteredArrows = [];
        for (let i = 0; i < 6; i++) {
            const filteredArrow = this.createArrow(filteredArrowColor);
            this.filteredArrows.push(filteredArrow);
            scene.add(filteredArrow);
        }
    }

    private createArrow(color: THREE.ColorRepresentation): THREE.Group {
        const shaftLength = 1.8;
        const headLength = 1;
        const shaftRadius = 0.35;
        const headRadius = 0.7;

        // Create the shaft of the arrow
        const shaftGeometry = new THREE.CylinderGeometry(shaftRadius, shaftRadius, shaftLength, 12);
        const shaftMaterial = new THREE.MeshBasicMaterial({ color: color });
        const shaft = new THREE.Mesh(shaftGeometry, shaftMaterial);

        // Create the head of the arrow
        const headGeometry = new THREE.ConeGeometry(headRadius, headLength, 12);
        const headMaterial = new THREE.MeshBasicMaterial({ color: color });
        const head = new THREE.Mesh(headGeometry, headMaterial);

        // Position the shaft and head
        shaft.position.set(0, shaftLength / 2, 0);
        head.position.set(0, shaftLength + headLength / 2, 0);

        // Create a group to combine shaft and head
        const arrow = new THREE.Group();
        arrow.add(shaft);
        arrow.add(head);

        return arrow;
    }

    public updateArrow(t: number): void {
        if (this.animationIsRunning) {
            const numArrows = this.arrows.length;
            const numFilteredArrows = this.filteredArrows.length;
            const spacing = 1 / numArrows;
            const filteredSpacing = 1 / numFilteredArrows;

            for (let i = 0; i < numArrows; i++) {
                const arrow = this.arrows[i];
                let tOffset = (t + i * spacing) % 1;
                if (this._state === TramoggiaState.PAUSED) {
                    tOffset = (i * spacing) % 1;
                }
                const position = this.curve.getPointAt(tOffset);
                const tangent = this.curve.getTangentAt(tOffset);

                // Update arrow position
                arrow.position.copy(position);

                // Update arrow orientation
                arrow.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), tangent.clone().normalize());
            }

            for (let i = 0; i < numFilteredArrows; i++) {
                const arrow = this.filteredArrows[i];
                let tOffset = ((t * 2.5) + i * filteredSpacing) % 1;
                if (this._state === TramoggiaState.PAUSED) {
                    tOffset = (2.5 + i * filteredSpacing) % 1;
                }
                const position = this.filteredCurve.getPointAt(tOffset);
                const tangent = this.filteredCurve.getTangentAt(tOffset);

                // Update arrow position
                arrow.position.copy(position);

                // Update arrow orientation
                arrow.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), tangent.clone().normalize());
            }
        }
    }

    public playArrowAnimation(scene: THREE.Scene): void {
        this.animationIsRunning = true;
        this.createArrows(scene);
    }

    public stopArrowAnimation(scene: THREE.Scene): void {
        scene.remove.apply(scene, this.arrows);
        scene.remove.apply(scene, this.filteredArrows);
        this.filteredArrows = [];
        this.arrows = [];
        this.animationIsRunning = false;
    }
}